import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'lib-popover-cell-renderer',
  templateUrl: './popover-cell-renderer.component.html',
  styleUrls: ['./popover-cell-renderer.component.scss']
})
export class PopoverCellRendererComponent  implements ICellRendererAngularComp {

  public params: IPopoverCellRendererParams;

  public agInit(params: IPopoverCellRendererParams): void {
    this.params = params;
    if (!this.params.popoverTriggerType) {
      this.params.popoverTriggerType = 'text';
    }
    if (!this.params.popoverPlacement) {
      this.params.popoverPlacement = 'bottom';
    }
  }

  public refresh(): boolean {
    return false;
  }

}

export interface IPopoverCellRendererParams extends ICellRendererParams {
  popoverTriggerType?: "ellipsis" | "text"; // clicking what type of element should trigger popover open. add more if needed
  popoverPlacement?: "top" | "bottom" | "left" | "right" | "auto";
  popoverLabel: string;
  popoverTitle?: string;
  popoverContent?: string; // Use to supply complex html content from outside. Used when links or text popover is not sufficient
  isTextPopover?: boolean; // whether it is a simple text popover
  popoverText?: string; // simple popover text
  isLinksPopover?: boolean; // whether it is a popover to display links
  links?: IPopoverCellRendererLink[]; // list of links to display in popover
}

export interface IPopoverCellRendererLink {
  displayValue: string;
  href: string;
  isDisabled?: boolean;
  disabledTooltipText?: string;
}
